function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.885 17.73v-1.688a3.377 3.377 0 0 0-3.377-3.377H6.754a3.377 3.377 0 0 0-3.377 3.377v1.688m6.754-8.443a3.377 3.377 0 1 0 0-6.754 3.377 3.377 0 0 0 0 6.754Z",
  stroke: "#F2F2F2",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIconMeusDados({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMeusDados);
export default __webpack_public_path__ + "static/media/icon-meus-dados.f49bd1129f000c3ce434aec2ac5cf79c.svg";
export { ForwardRef as ReactComponent };